import { Action } from 'redux';
import { Sede } from '../../../models/Entities/Turnero';
import { TurneroSedesState, TurneroSedesUnloadState } from '../../states/Turnero-Sedes.State';

export default function TurneroSedesReducer(
    state: TurneroSedesState | undefined,
    action: Action
): TurneroSedesState {
    const currentState = state ?? TurneroSedesUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-SEDES_GET_ALL_REQUEST':
            return {
                ...currentState,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined
            } as TurneroSedesState;
        case 'TURNERO-SEDES_GET_ALL_SUCCESS':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                list: a.payload || []
            } as TurneroSedesState;
        case 'TURNERO-SEDES_GET_ALL_FAILURE':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: a.error
            } as TurneroSedesState;

        case 'TURNERO-SEDES_CREATE_REQUEST':
            return {
                ...currentState,
                isAddingNewOne: true,
                successAddingNewOne: false,
                failOnAddingNewOne: false,
                error: undefined
            } as TurneroSedesState;
        case 'TURNERO-SEDES_CREATE_SUCCESS':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                error: undefined,
                list: [...(currentState.list || []), a.payload]
            } as TurneroSedesState;
        case 'TURNERO-SEDES_CREATE_FAILURE':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: a.error
            } as TurneroSedesState;

        case 'TURNERO-SEDES_UPDATE_REQUEST':
            return {
                ...currentState,
                isUpdatingOne: true,
                successUpdatingOne: false,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroSedesState;
        case 'TURNERO-SEDES_UPDATE_SUCCESS':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: true,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroSedesState;
        case 'TURNERO-SEDES_UPDATE_FAILURE':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: false,
                failOnUpdatingOne: true,
                error: a.error
            } as TurneroSedesState;

        case 'TURNERO-SEDES_DELETE_REQUEST':
            return {
                ...currentState,
                isDeletingOne: true,
                successDeletingOne: false,
                failOnDeletingOne: false,
                error: undefined
            } as TurneroSedesState;
        case 'TURNERO-SEDES_DELETE_SUCCESS':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: true,
                failOnDeletingOne: false,
                error: undefined,
                list: (currentState.list || []).filter((s: Sede) => s.id !== a.payload)
            } as TurneroSedesState;
        case 'TURNERO-SEDES_DELETE_FAILURE':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: false,
                failOnDeletingOne: true,
                error: a.error
            } as TurneroSedesState;

        default:
            return currentState as TurneroSedesState;
    }
}
